import {type PaletteOptions} from '@mui/material';
import {cyan} from '@mui/material/colors';

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    light: '#FFEF70',
    main: '#D9BC3F',
    dark: '#A48D00',
    contrastText: '#000000',
  },
  secondary: {
    main: '#9BB4BE',
    dark: '#216071',
    light: '#C1D1D7',
  },
  text: {
    primary: '#B5C7CF',
    secondary: '#9BB4BE',
    disabled: '#7EA9B690',
  },
  action: {},
  background: {
    default: '#061920',
    paper: '#081f26',
  },
  error: {
    dark: '#D5190B',
    main: '#f44336',
    light: '#F76E64',
  },
  warning: {
    dark: '#C56300',
    main: '#F26800',
    light: '#F7C137',
    contrastText: '#ffffff',
  },
  info: {
    main: '#5CC0DF',
    dark: '#4CA4BF',
    light: '#88D1E7',
  },
  success: {
    dark: '#388E3C',
    main: '#66BB6A',
    light: '#81C784',
    // contrastText: '#ffffff',
  },
  good: {
    main: '#42CB8A',
  },
  bad: {
    main: '#FF8E93',
  },
  neutral: {
    main: '#DCDCDC',
  },
  input: {
    main: '#ade0d9',
  },
  harvest: {
    main: '#F7C137',
  },
  transfer: {
    main: '#faa7a7',
  },
  tableViewBackgroundColor: {
    main: '#26393F',
    light: '#0B232C',
    dark: '#1B3137',
  },
  graph: {
    main: cyan[800],
    light: cyan[700],
    dark: cyan[900],
  },
  delousing: {
    main: '#8B45A3',
  },
};
